export default __webpack_public_path__ + "static/media/room-map.6b9ad06c.png";